module.exports = __webpack_public_path__ + "media/src/images/feature-bg-01-290d3f66ab6f22802b76a3240cfda04e.png";